module.exports = __webpack_public_path__ + "img/3@2x.f68084de.png";